import { createSelector } from "reselect";
import { AppState } from "state/store";
const selector = (state: AppState) => state.survey;

export default createSelector([selector], (data) => data);